import {Component, Inject, Optional} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent, MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {NgForOf, NgIf} from "@angular/common";
import {DropDownOption} from "../../../shared/Models/shared-data-models.model";
import {FormsModule} from "@angular/forms";

type DialogData = {
    title: string;
    options: DropDownOption<any>[];
};

@Component({
  selector: 'app-user-extended-label-option-select',
    imports: [
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatRadioButton,
        MatRadioGroup,
        NgForOf,
        FormsModule,
        NgIf
    ],
  templateUrl: './user-extended-label-option-select.component.html',
  styleUrl: './user-extended-label-option-select.component.scss'
})
export class UserExtendedLabelOptionSelectComponent {
    dialogTitle: string = "";
    dialogOptions: DropDownOption<any>[] = [];
    selectedOption: string;

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) private data: DialogData,
        private dialogRef: MatDialogRef<UserExtendedLabelOptionSelectComponent>,
    ) {}

    ngOnInit() {
        if (this.data) {
            this.dialogTitle = this.data.title;
            this.dialogOptions = this.data.options;
            this.selectedOption = this.dialogOptions[0].value.accountId;
        }
    }

    handleResponse() {
        this.dialogRef.close(this.selectedOption);
    }
}
